module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-check-a9573bef.svg";